<template>
    <div class="w-full mdr:px-0 mdr:py-0 px-32 py-16 bg-[#313131]">
        <div class="title-page-section flex flex-wrap justify-between mdr:flex-col">
            <h1 class="text-9xl pb-16"><span class="border-b border-white">{{title}}</span></h1>
            <search-artist @toggle="(value) =>getDataEmit(value)" />
        </div>
    </div>
   
    <div class="cards">
        <div class="flex flex-wrap flex-row justify-center items-center main-content">
            <div v-for="actor in state.actors" :key="actor.id" class="w-full md:w-1/3 lg:w-1/5 xl:w-1/6 single-actor">
                <a
                :href="actor.link">
                <card-item :featured="actor.featured_media" :const-height="mq.xxl || mq.xs ? '550px': '450px'"  :dataImage="actor.featured_guid ? actor.featured_guid : '' ">
                    <template v-slot:header>
                        <p class="text-2.6rem"><a :href="actor.link" :title="actor.title.rendered">{{ getTitleCard(actor) }}</a></p>
                    </template>
                </card-item>
            </a>
            </div>
        </div>
       
    </div>
    <div class="limit-cards relative h-16" ref="scrollRef"></div>
        <loader :loading="isLoading" />
</template>

<script>
import { ref, onMounted, reactive } from 'vue'
import { getArtistsCategories } from '../../scripts/getAxios'
import { onIntersect } from '../../scripts/onintersect'
import {parseHtmlEntities} from '../../scripts/utils'
import { useMq } from "vue3-mq";



export default {
    inject: ["mq"],
    name: 'cards',
    props: {
        termid: {
            type: Number,
            deafult: 0
        },
        title:{
            type: String,
            default: ''
        },
        nonce:{
          type: String,
          default:''  
        },
        isLogged:{
            type: Boolean,
            default: false
        },
    },
    setup(props) {
        const mq = ref(useMq())
        const { termid, nonce, isLogged, dataImage } = { ...props }
        const last_page = ref(0)
        const scrollRef = ref({})
        const page = ref(1)
        const isLoading = ref(false)
        const isOpened = ref(false);
        const state = reactive({
            actors: [],
            objectObserver: null
        })
        let onload = true
        let params = {
            page: 1,
            per_page: mq.xxl ? 18 : 12,
            orderby:'semme_cognome',
            order:'asc',
            li: isLogged
        }
        const getDataEmit = (value) =>{
        last_page.value = 0
        onload = false
        params = {}
        params.page= 1
        params.li=isLogged
        params.per_page =  12
        params.orderby='semme_cognome'
        params.order='asc'
        state.actors =[]
        params = {...params, ...value}
        importArtists()
        
        }
        const getTitleCard = (actor =>{
            const {rendered} = actor.title 
           return  parseHtmlEntities(rendered)
        })
        const importArtists = async () => {
           const domain = process.env.WORDPRESS_BASE_URL
           /* await getArtistsCategories(`${domain}/wp-json/wp/v2/artisti?${!params.sesso && params.onload ? `artist_categories=${termid}` : ''}`,
                params, nonce)
                .then(res => {
                    state.actors.push(...res.data)
                    last_page.value = res.headers['x-wp-totalpages']
                    isLoading.value = false
                })
                .catch(error =>{
                    console.log(error)
                })*/
               
                const paramsQuery = new URLSearchParams(params);
                if (!params.sesso && onload){
                    paramsQuery.append('artist_categories', termid)
                }

                var requestOptions = {
                method: 'GET',
                };
                const fetchUrl = isLogged || params.lingua ? `${domain}/wp-json/wp/v2/artistilogged?` : `${domain}/wp-json/wp/v2/artisti?`
                fetch(fetchUrl + paramsQuery, requestOptions)
                .then(response =>{
                    const headers = response.headers;
                    last_page.value = headers.get('x-wp-totalpages')
                    return response.json();
                })
                .then(res => {
                    state.actors.push(...res)
                    isLoading.value = false
                })
                .catch(error => console.log('error', error));
        }
        const observeSections = () => {
            const options = {
                root: null,
                rootMargins: '0px',
                threshold: 0.1
            }
            state.objectObserver = new onIntersect(scrollRef.value, sectionObserveHandler, null, false, options)
        }

        const sectionObserveHandler = () => {
            if (params.page < last_page.value) {
                params.page = params.page + 1
                isLoading.value = true
                importArtists();
            }else if (params.page == last_page.value){
                state.objectObserver = observe().disconnect
            }
        }

        onMounted(async () => {
            console.log('mq',mq)
            importArtists()
            observeSections()
        })

        return {
            state,
            scrollRef,
            last_page,
            isLoading,
            isOpened,
            getDataEmit,
            getTitleCard,
            mq
        }
    },
}
</script>

<style lang="scss" scoped>

</style>